import { render, staticRenderFns } from "./Backtotop.vue?vue&type=template&id=64f65d17&scoped=true"
import script from "./Backtotop.vue?vue&type=script&lang=js"
export * from "./Backtotop.vue?vue&type=script&lang=js"
import style0 from "./Backtotop.vue?vue&type=style&index=0&id=64f65d17&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f65d17",
  null
  
)

export default component.exports